import { noop } from "lodash";
import { CAM_ENABLED } from "./config";

export const useCAMHook = <T>(hook: T) => {
  return CAM_ENABLED ? hook : noop;
};
